import { TextProps } from '@chakra-ui/react';
import { type ComponentProps, type FC } from 'react';
import { zeroAddress } from 'viem';
import CryptoCurrencyIcon from './CryptoCurrencyIcon';
import FormatCrypto from './FormatCrypto';

type FormatCryptoCurrencyProps = TextProps & {
  logoHeight?: number;
  address?: string;
  logoSrc?: string;
  symbol?: string;
};

type Props = ComponentProps<typeof FormatCrypto> & FormatCryptoCurrencyProps;

const FormatCryptoCurrency: FC<Props> = ({
  amount,
  address = zeroAddress,
  maximumFractionDigits,
  logoHeight = 8,
  decimals,
  logoSrc,
  symbol,
  ...textProps
}) => {
  return (
    <FormatCrypto
      amount={amount}
      maximumFractionDigits={maximumFractionDigits}
      decimals={decimals}
      textProps={textProps}
    >
      <CryptoCurrencyIcon
        logoSrc={logoSrc}
        css={{ height: logoHeight }}
        address={address}
        symbol={symbol}
      />
    </FormatCrypto>
  );
};

export default FormatCryptoCurrency;
